import { makeStyles } from '@material-ui/core';
import { fonts, MEDIUM } from '../../../abstracts/constants';

export const useStyles = makeStyles({
  root: {
    padding: 0,
    margin: 0,
  },
  ol: {
    height: '32px',
  },
  li: {
    height: '24px',
    margin: '4px 0',
    fontFamily: fonts.sourceSansPro,
    '& span': {
      '& a': {
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.5',
        letterSpacing: 'normal',
      },
    },
  },
  separator: {
    height: '16px',
    lineHeight: '16px',
    fontSize: MEDIUM,
    margin: '8px 6px',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
  },
});
